import {NavItemLink, NavItemHashLink } from "./navItem";
import logo from '../static/images/sw_logo.jpg'
import LinkComponent from "./link";
import { InstagramComponent, FacebookComponent, TwitterComponent, DoordashComponent } from "./externallink";
import CartComponent from "./cart/cartComponent";

function NavBar() {
    return (
    <section style={{backgroundColor: "white", zIndex: "1000"}} className="position-fixed top-0 left-0 w-100">
        <nav className="navbar navbar-expand-md">
            <div className="container-fluid">
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <a className="navbar-brand d-none d-md-block" href="/">
                    <LinkComponent link={"/"} component={<img src={logo} alt="Logo" className="logo" style={{maxWidth: "240px"}}></img>} />
                </a>
                <a className="navbar-brand align-items-center d-md-none" href="/">
                    <LinkComponent link={"/"} component={<img src={logo} alt="Logo" className="logo" style={{maxWidth: "210px"}}></img>}/>
                </a>
                <ul className="navbar-nav align-items-center mx-auto d-none d-md-flex" style={{fontSize: "clamp(1rem, 4vw, 2rem)"}}>
                    <NavItemLink text={"Shop All"} className={"nav-item mx-1"} rel={"/inventory"}/>
                    <NavItemLink text={"Occasions"} className={"nav-item mx-1"} rel={"/inventory"}/>
                    <NavItemLink text={"Valentine's Day"} className={"nav-item mx-1"} rel={"/inventory"}/>
                    <NavItemHashLink text={"Contact"} className={"nav-item mx-1"} rel={"#footerSection"}/>
                </ul>
        
                <ul className="navbar-nav align-items-center d-none d-md-flex" style={{fontSize: "clamp(1rem, 4vw, 2rem)"}}>
                    {/* <NavItemLink text={"Login"} className={"nav-item mx-4"}/> */}
                    <InstagramComponent className={"nav-item mx-4"}/>
                    <FacebookComponent className={"nav-item mx-4"}/>
                    <TwitterComponent className={"nav-item mx-4"}/>
                    <DoordashComponent className={"nav-item mx-4"}/>
                    <CartComponent className={"nav-item mx-4 pb-2"}/>
                </ul>
                <div className="d-md-none" style={{fontFamily: 'Poppins', fontSize: "xx-large", fontWeight: "bold"}}>
                    <CartComponent className={"nav-item mx-4 pb-3"}/>
                </div>
            </div>
        </nav>
        <div className="collapse d-sm-none navbar-collapse z-2 position-relative bg-light bg-gradient" style={{fontFamily: 'Poppins', fontSize: "large", fontWeight: "bold"}} id="navbarContent">
            <ul className="navbar-nav align-items-center mx-auto d-md-flex">
                <NavItemLink text={"Shop All"} className={"nav-item"} rel={"/inventory"}/>
                <NavItemLink text={"Occasions"} className={"nav-item"} rel={"/inventory"}/>
                <NavItemLink text={"Fall Flowers"} className={"nav-item"} rel={"/inventory"}/>
                <NavItemHashLink text={"Contact"} className={"nav-item"} rel={"#footerSection"}/>
            </ul>
            <ul className="navbar-nav justify-content-center align-items-center flex-row mx-auto d-md-flex">
                <InstagramComponent className={"nav-item mx-2"}/>
                <FacebookComponent className={"nav-item mx-2"}/>
                <TwitterComponent className={"nav-item mx-2"}/>
                <DoordashComponent className={"nav-item mx-2"}/>
            </ul>
        </div>
    </section>
    );
}

export default NavBar;